const ADMIN = 'ADMIN';
const EV_MASTER = 'EV_MASTER';
const EV_BRANCH = 'EV_BRANCH';
const SAT = 'SAT';
const EV_ISUZU = 'EV_ISUZU'
const EV_INPUT = 'EV_INPUT'

export {ADMIN, EV_MASTER, EV_BRANCH, SAT, EV_ISUZU, EV_INPUT}